import React, { Fragment, useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import {
  RNCANCELOFFER,
  RNPURCHASEOFFER,
} from '../../services/common/endpoints';
import { callQueryapi } from '../../services/http/callapi';
import MessageModal from '../common/bottom-modal-message';
import { useSelector } from 'react-redux';
import { getItemOfSessionStorage } from '../../services/common/utils';
import { SELECTED_LANG } from '../../services/common/Constants';

const ShamelProControl = ({ lineDetails }) => {
  const lang = getItemOfSessionStorage(SELECTED_LANG);
  const [offersList, setOffersList] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [showMessage, setShowMessage] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showDeactivateSuccessMessage, setShowDeactivateSuccessMessage] =
    useState(false);

  const customerprofile = useSelector(
    (state) => state.userdata.value.customerprofile
  );
  const isPostpaid = customerprofile?.RatePlanType === "POSTPAID";

  useEffect(() => {
    if (
      lineDetails?.data?.data?.response?.Shamelprocontroles?.offers?.length > 0
    ) {
      setOffersList(
        lineDetails?.data?.data?.response?.Shamelprocontroles?.offers
      );
    }
  }, [lineDetails]);

  const activate2 = useQuery(
    [
      {},
      RNPURCHASEOFFER,
      {
        offerid: selectedOffer?.offerid,
        offergroup: '',
        purchaseaction: '',
      },
      {},
    ],
    {
      enabled: false,
      retry: false,
      cacheTime: 0,
      staleTime: 0,
      onSuccess: (udata, variables, context) => {
        //if (udata?.data?.status == '0') {
        setShowMessage(false);
        setShowSuccessMessage(true);
        lineDetails.refetch();
        //}
      },
    }
  );

  const deactivate2 = useQuery(
    [
      {},
      RNCANCELOFFER,
      {
        offerid: selectedOffer?.offerid,
        isimmediatecancel: '1',
        isstopfallbackpurchase: '',
      },
      {},
    ],
    {
      enabled: false,
      retry: false,
      cacheTime: 0,
      staleTime: 0,
      onSuccess: (udata, variables, context) => {
        //if (udata?.data?.status == '0') {
        setShowMessage(false);
        setShowDeactivateSuccessMessage(true);
        lineDetails.refetch();
        //}
      },
    }
  );

  const activate = useMutation(
    (offerid) =>
      callQueryapi({
        queryKey: [
          {},
          RNPURCHASEOFFER,
          {
            offerid: offerid,
            offergroup: '',
            purchaseaction: '',
          },
        ],
      }),
    {
      onSuccess: (udata) => {
        if (udata?.data?.status == '0') {
          setShowMessage(false);
          setShowSuccessMessage(true);
          lineDetails.refetch();
        }
      },
    }
  );

  const deactivate = useMutation(
    (offerid) =>
      callQueryapi({
        queryKey: [
          {},
          RNCANCELOFFER,
          {
            offerid: offerid,
            isimmediatecancel: '1',
            isstopfallbackpurchase: '',
          },
        ],
      }),
    {
      onSuccess: (udata, variables, context) => {
        if (udata?.data?.status == '0') {
          setShowMessage(false);
          setShowDeactivateSuccessMessage(true);
          lineDetails.refetch();
        }
      },
    }
  );

  const handleCancel = () => {
    setShowMessage(false);
    setSelectedOffer(null);
  };

  const handleConfirm = () => {
    if (!selectedOffer?.isshamelproactive) {
      activate2.refetch();
    } else {
      deactivate2.refetch();
    }
  };

  const handleOk = () => {
    setShowSuccessMessage(false);
    setShowDeactivateSuccessMessage(false);
    setSelectedOffer(null);
  };

  if (!lineDetails?.data?.data?.response?.Shamelprocontroles || !isPostpaid) {
  return <></>
  }

  return (
    <>
      <div class="mt-30">
        <div class="card_style_2 icon_img_desc_style p-3">
          <div class="card_info">
            <div class="card_info_grp m-0">
              <h4 class="text-ellipsis">
                {lineDetails?.data?.data?.response?.Shamelprocontroles?.title}
              </h4>
            </div>
            <hr />
            <div>
              <p>
                {
                  lineDetails?.data?.data?.response?.Shamelprocontroles
                    ?.description
                }
              </p>
            </div>
            <div>
              <div class="row align-items-center">
                {offersList?.map((offer, index) => {
                  return (
                    <Fragment key={offer?.offerid}>
                      <div class="col-6 mt-3">
                        <h6 class="primary_14 text-ellipsis m-0 align-items-start">
                          {offer?.offername}
                        </h6>
                      </div>
                      <div class="col-6 mt-3">
                        <div class="d-flex align-items-center justify-content-end">
                          <div className={`action_grp ${lang === 'ar' ? '' : ''}`}>
                            <div class="cs_toggle_btn ms-3">
                              <input
                                type="checkbox"
                                id={`id-${index}`}
                                checked={offer?.isshamelproactive}
                              />
                              <label
                                id={`id-${index}`}
                                onClick={() => {
                                  setSelectedOffer(offer);
                                  setShowMessage(true);
                                }}
                              >
                                &nbsp;
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Fragment>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      <MessageModal
        type="3A"
        show={showMessage}
        message={selectedOffer?.confirmation_msg}
        handleCancel={handleCancel}
        handleConfirm={handleConfirm}
        loading={activate2?.isLoading || activate2?.isFetching || deactivate2.isLoading || deactivate2.isFetching}
        pBtnText='PROCEED'
      />

      <MessageModal
        type="2"
        show={showSuccessMessage}
        message={activate2?.data?.data?.message}
        handleOk={handleOk}
      />

      <MessageModal
        type="2"
        show={showDeactivateSuccessMessage}
        message={deactivate2?.data?.data?.message}
        handleOk={handleOk}
      />
    </>
  );
};

export default ShamelProControl;
